import RestClient from '../../common/modules/rest';
import { API } from '../../common/settings';

const rest = new RestClient();
const validateCustomerReferenceNumberEndpoint = API.API_ENDPOINTS.VALIDATE_CRN_AND_POSTCODE;
const postcodeLookupEndpoint = API.API_ENDPOINTS.POSTCODE_LOOKUP;
const addressDetailsEndpoint = API.API_ENDPOINTS.MOVE_OUT_ADDRESS_DETAILS;

export const validateCustomerReferenceNumber = (params) =>
  rest.post(`${validateCustomerReferenceNumberEndpoint}`, params);

export const fetchAddresses = (postcode, buildingNumber) =>
  rest.get(
    `${postcodeLookupEndpoint}/search?BuildingNameNumber=${
      buildingNumber ? encodeURIComponent(buildingNumber) : ''
    }&Postcode=${postcode}`,
  );

export const fetchAddressDetails = (id) => rest.get(`${addressDetailsEndpoint}${id}`);
